module.exports = __webpack_public_path__ + "img/success_e.2f2cdea5.gif";